import React from "react"
import { store } from "../../../../../../stores/Store"
import Field from "../../../../../form/fields/Field"
import { SelectOption } from "../../../../../form/fields/SelectField"
import { Button } from "@mui/material"
import Ajax from "../../../../../../Ajax"
import { Alert } from "../../../../../.."

export default function WorkflowCreateForm ({caseNode}) {

    const [loading, setLoading] = React.useState(null)
    const [workflowUid, setWorkflowUid] = React.useState(null)
    const workflows = store.AppStore.workflows
    const options: SelectOption[] = workflows?.map(workflow => {
        return {value: workflow.uid, label: workflow.label, help: workflow.description}
    })

    const submit = async () => {
        setLoading(true)
        
        await Ajax.Workflow.Create(caseNode.uid, workflowUid).then(async () => {
            await store.NodeStore.refreshFolderNode()
        }).catch(() => {
            Alert({message: "Failed to create workflow"})
        })
        
        setLoading(false)
    }

    if (!workflows?.length) {
        return <></>
    }

    return (
        <div className={loading ? "disabled" : ""}>
            <h3>Workflow</h3>
            
            <p>You have {workflows?.length} workflow options.</p>

            <Field.Select 
                formik 
                label="Select a workflow" 
                style={{maxWidth: "300px"}}
                options={options}
                value={workflowUid}
                onChange={(e) => setWorkflowUid(e.target.value)} />

            {workflowUid ? (
                <Button 
                    className="btn btn-sm" 
                    color="success" 
                    variant="contained" 
                    disabled={loading}
                    onClick={() => submit()}>
                    Create Workflow
                </Button>
            ) : null}
        </div>
    )
}